import { useQuery } from "@apollo/client";
import Button from "components/base/Button";
import Errors from "components/base/Errors";
import Page from "components/base/Page";
import Spinner from "components/base/Spinner";
import { useModals } from "ModalProvider";
import { useNavigate, useParams } from "react-router-dom";
import ForecastCategoryCardView from "./ForecastCategoryCardView";
import ForecastCategoryFormView from "./ForecastCategoryFormView";
import { FETCH_FORECAST_CATEGORIES } from "./graphql";

const ForecastCategoriesPage = () => {
  const categoryModal = useModals();
  const navigate = useNavigate();
  const { mode } = useParams();
  const { loading, error, data, refetch } = useQuery(
    FETCH_FORECAST_CATEGORIES,
    {
      variables: { mode },
      fetchPolicy: "network-only",
    },
  );

  function addCategory() {
    categoryModal.present({
      title: "Add Category",
      center: true,
      children: (
        <ForecastCategoryFormView
          mode={mode}
          hide={categoryModal.hide}
          onCompleted={(category) => navigate(category.id)}
        />
      ),
    });
  }

  if (loading) return <Spinner />;
  if (error) return <Errors error={error} />;

  const categories = data?.forecastCategories || [];

  return (
    <Page
      title={`${mode} / Forecast Categories`}
      backTo="./.."
      rightButtons={
        mode !== "INC" && (
          <div>
            <Button onClick={addCategory} primary={categories.length === 0}>
              + Add Category
            </Button>
          </div>
        )
      }
    >
      <div className="p-6 grid grid-cols-3 gap-6">
        {categories.length === 0 && (
          <div className="col-span-3 text-center text-gray-500">
            No forecast categories at the monent. Click + Add Category to create
            one.
          </div>
        )}

        {categories.map((category) => (
          <ForecastCategoryCardView
            key={category.id}
            category={category}
            onChanged={refetch}
            readOnly={category.mode === "INC"}
          />
        ))}
      </div>
    </Page>
  );
};

export default ForecastCategoriesPage;
